import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const UserPlus = () => (
  <ImageIcon src={Images.UserPlus} alt="User Plus" />
);

export default UserPlus;
